import {Event, EventResponse, KeyEvent} from "../../dtos/eventResponse"

const getEventPerTypePerItem = (events: Event[], eventType: string): Map<string, Event[]> => {
	let eventsMap = new Map<string, Event[]>([])
	let filteredEvents = events.filter((event) => event.type === eventType)
	filteredEvents.forEach((event) => {
		const itemId = event.itemInfo[0].itemId
		if (eventsMap.get(itemId)) {
			eventsMap.set(itemId, [...eventsMap.get(itemId)!, event])
		} else {
			eventsMap.set(itemId, [event])
		}
	})
	return eventsMap
}

export const getShippingEventsPerItem = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "LINE_ITEM_FULFILLMENT_SHIPPED") //consider this event
}
export const getDeliveryUpdatedEvents = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "GENERIC_FULFILLMENT_UPDATE")
}

export const getDeliveryEventsPerItem = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "LINE_ITEM_FULFILLMENT_DELIVERED")
}

export const getRefundRequestEventsPerItem = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "LINE_ITEM_REFUND_REQUESTED")
}

export const getRefundEventsPerItem = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "LINE_ITEM_REFUNDED")
}

export const getFulfillmentAcceptedEventsPerItem = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "LINE_ITEM_FULFILLMENT_ACCEPTED")
}

export const getStateChangedEventsPerItem = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "LINE_ITEM_STATE_CHANGED")
}

export const getMcpItemId = (events: Event[], merchantItemId: string): string => {
	const platformAcceptedEvents = events.filter(
		(event) => event.type === "FULFILLMENT_PLATFORM_ACCEPTED"
	)
	let targetEvent = platformAcceptedEvents
		? platformAcceptedEvents[platformAcceptedEvents.length - 1]
		: undefined
	if (targetEvent && targetEvent.eventProperties && targetEvent.eventProperties.details) {
		const itemMapping = targetEvent.eventProperties.details.find(
			(item) => item.merchantItemId === merchantItemId
		)
		return itemMapping ? itemMapping!.itemId : merchantItemId
	} else {
		return merchantItemId
	}
}

export const isLineItemRejected = (stateChangedEvents: Event[] | undefined) => {
	if (stateChangedEvents) {
		const lastEvent = stateChangedEvents[0]
		if (
			lastEvent &&
			lastEvent.itemInfo &&
			lastEvent.itemInfo[0] &&
			lastEvent.itemInfo[0].itemProperties &&
			lastEvent.itemInfo[0].itemProperties.toState
		)
			return (
				lastEvent.itemInfo[0].itemProperties.toState.toLocaleUpperCase() === "REJECTED" ||
				(lastEvent.itemInfo[0].itemProperties.fromState.toLocaleUpperCase() === "REJECTED" &&
					lastEvent.itemInfo[0].itemProperties.toState.toLocaleUpperCase() === "CANCELSUCCESS")
			)
	}
	return false
}

export const getInvalidReplacementEventsPerItem = (events: Event[]): Map<string, Event[]> => {
	return getEventPerTypePerItem(events, "LINE_ITEM_INVALID_REPLACEMENT_REQUESTED")
}

export const getShippedEventByTrackingId = (
	trackingId: string,
	itemId: string,
	events: Event[]
): Event | undefined => {
	const shippingEventsPerItem = getShippingEventsPerItem(events)
	if (shippingEventsPerItem) {
		return shippingEventsPerItem.get(itemId)
			? shippingEventsPerItem
					.get(itemId)!
					.filter(
						(x: Event) =>
							x.itemInfo &&
							x.itemInfo.length > 0 &&
							x.itemInfo[0].itemProperties &&
							x.itemInfo[0].itemProperties.trackingId &&
							trackingId === x.itemInfo[0].itemProperties.trackingId
					)[0]
			: undefined
	}
	return undefined
}

export const getDeliveryEventByTrackingId = (
	trackingId: string,
	itemId: string,
	events: Event[]
): Event | undefined => {
	const deliveryEventsPerItem = getDeliveryEventsPerItem(events)
	return deliveryEventsPerItem.get(itemId)
		? deliveryEventsPerItem
				.get(itemId)!
				.filter(
					(x: Event) =>
						x.eventProperties &&
						x.eventProperties.details &&
						x.eventProperties.details.length > 0 &&
						x.eventProperties.details[0] &&
						x.eventProperties.details[0].additionalData &&
						x.eventProperties.details[0].additionalData.trackingId &&
						trackingId === x.eventProperties.details[0].additionalData.trackingId
				)[0]
		: undefined
}
export const getEventDeliveryUpdated = (
	trackingURL: string,
	itemId: string,
	events: Event[]
): Event | undefined => {
	const deliveryUpdate = getDeliveryUpdatedEvents(events)
	return deliveryUpdate.get(itemId)
		? deliveryUpdate
				.get(itemId)!
				.filter(
					(x: Event) =>
						x.eventProperties &&
						x.eventProperties.details &&
						x.eventProperties.details.length > 0 &&
						x.eventProperties.details[0] &&
						x.eventProperties.details[0].additionalData &&
						x.eventProperties.details[0].additionalData.trackingId &&
						trackingURL === x.eventProperties.details[0].additionalData.trackingUrl
				)[0]
		: undefined
}
export const getKeyEvents = (itemEvents: Event[]): Event[] => {
	let events = itemEvents
	let eventTypes = events.map((event) => {
		return event.type
	})
	if (eventTypes.includes("LINE_ITEM_REPLACEMENT_REQUESTED")) {
		const replacementEventLastIndex = eventTypes.indexOf("LINE_ITEM_REPLACEMENT_REQUESTED")
		events = itemEvents.slice(0, replacementEventLastIndex)
		eventTypes = eventTypes.slice(0, replacementEventLastIndex)
	}
	events = events.filter((event) => keyEvents.includes(event.type))
	if (
		eventTypes.includes("LINE_ITEM_CANCEL_REQUEST_SUCCEEDED") &&
		eventTypes.includes("LINE_ITEM_FULFILLMENT_CANCELLED")
	) {
		const index = events.findIndex((event) => event.type === "LINE_ITEM_FULFILLMENT_CANCELLED")
		if (index > -1) {
			events.splice(index, 1)
		}
	}
	return events
}
export const getItemStatus = (events: Event[]): string => {
	let eventTypes = events.map((event) => {
		return event.type
	})
	if (eventTypes.includes("LINE_ITEM_REPLACEMENT_REQUESTED")) {
		const replacementEventLastIndex = eventTypes.indexOf("LINE_ITEM_REPLACEMENT_REQUESTED")
		eventTypes = eventTypes.slice(0, replacementEventLastIndex)
	}
	eventTypes = eventTypes.filter((event) => keyEvents.includes(event))
	if (
		eventTypes.includes("LINE_ITEM_CANCEL_REQUEST_SUCCEEDED") &&
		eventTypes.includes("LINE_ITEM_FULFILLMENT_CANCELLED")
	) {
		const index = eventTypes.indexOf("LINE_ITEM_FULFILLMENT_CANCELLED")
		if (index > -1) {
			eventTypes.splice(index, 1)
		}
	}
	return getStatusByEventType(eventTypes[0])
}
const getStatusByEventType = (eventType: string): string => {
	if (
		["LINE_ITEM_FULFILLMENT_CANCELLED", "LINE_ITEM_CANCEL_REQUEST_SUCCEEDED"].includes(eventType)
	) {
		return "Cancelled"
	}
	const statuses = Object.keys(statusesEventsMap).filter(
		(key) => statusesEventsMap[key] === eventType
	)
	if (statuses && statuses.length > 0) {
		return statuses[0]
	}
	return "Order created"
}
export const getOrderItemTimeLine = (
	itemEvents: Event[],
	orderCreationDate: string
): ItemTimelineDetail[] => {
	const events = getKeyEvents(itemEvents)
	let itemsTimeLine: ItemTimelineDetail[] = []
	itemsTimeLine.push({
		status: "Order created",
		date: orderCreationDate,
		highlighted: true,
	})
	events.reverse().forEach((event) => {
		itemsTimeLine.push({
			status: getStatusByEventType(event.type),
			date: event.dateTime,
			highlighted: true,
		})
	})
	const itemStatus = itemsTimeLine[itemsTimeLine.length - 1].status
	if (
		["Rejected", "Cancelled"].includes(itemStatus) ||
		(itemStatuses.length > itemsTimeLine.length && itemStatus !== "Delivered")
	) {
		const startIndex = ["Rejected", "Cancelled"].includes(itemStatus)
			? itemsTimeLine.length - 1
			: itemStatuses.indexOf(itemStatus) + 1
		for (var i = startIndex; i < itemStatuses.length; i++) {
			itemsTimeLine.push({
				status: itemStatuses[i],
				date: "",
				highlighted: false,
			})
		}
	}
	return itemsTimeLine
}

export const getItemDeliveryDate = (itemEvents: Event[], itemId: string): string => {
	const events = getKeyEvents(itemEvents)
	const deliveryEvents = events.filter((event) => event.type === "ORDER_EMAIL_SENT_ITEM_DELIVERED")
	if (
		deliveryEvents &&
		deliveryEvents.length > 0 &&
		deliveryEvents[0] &&
		deliveryEvents[0].itemInfo &&
		deliveryEvents[0].itemInfo.length > 0
	) {
		const itemInfo = deliveryEvents[0].itemInfo.filter((item) => item.itemId === itemId)
		if (itemInfo && itemInfo.length > 0) {
			if (
				itemInfo[0] &&
				itemInfo[0].itemProperties &&
				itemInfo[0].itemProperties.deliveryUpdatedDate
			) {
				return itemInfo[0].itemProperties.deliveryUpdatedDate
			}
		}
	}
	return ""
}
export const getEventCreationDate = (events: Event[], eventType: string): string => {
	let keyEvents = events
	if (eventType !== "ORDER_CREATED" && eventType !== "ORDER_PAID") {
		keyEvents = getKeyEvents(events)
	}
	const filteredEvents = keyEvents.filter((event) => event.type === eventType)
	if (filteredEvents && filteredEvents.length > 0) {
		return filteredEvents[0].dateTime
	}
	return ""
}
const getItemsWithSpecificEvent = (
	eventType: string,
	eventResponse: EventResponse
): itemEvent[] => {
	let itemEvents: itemEvent[] = []
	eventResponse.itemEvents.forEach((item) => {
		const ItemKeyEvents = item.events
		let events = ItemKeyEvents.map((keyEvent) => {
			return keyEvent.event
		})
		events = getKeyEvents(events)
		const fileteredEvents = events.filter((event) => event.type === eventType)
		if (fileteredEvents && fileteredEvents.length > 0) {
			itemEvents.push({
				itemId: item.itemdId,
				event: fileteredEvents[0],
			})
		}
	})
	return itemEvents
}
const getStartDate = (itemEvents: itemEvent[]): string => {
	if (itemEvents.length > 0) {
		const events = itemEvents.map((itemEvent) => {
			return itemEvent.event
		})
		const sortedEvents = events.sort(
			(a: Event, b: Event) => new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
		)
		return sortedEvents[0].dateTime
	}
	return ""
}
export const getOrderEventsTimeline = (
	orderCreationDate: string,
	eventResponse: EventResponse | null
): OrderTimelineDetail[] => {
	let eventsTimeline: OrderTimelineDetail[] = []
	if (orderCreationDate) {
		eventsTimeline.push({
			status: "Order created",
			startDate: orderCreationDate,
		})
	}
	if (eventResponse) {
		const orderEvents = eventResponse.orderEvents.map((orderEvent) => {
			return orderEvent.event
		})
		orderStatuses.forEach((status) => {
			switch (status) {
				case "Order created":
					break
				case "Order paid": {
					eventsTimeline.push({
						status: "Order paid",
						startDate: getEventCreationDate(orderEvents, "ORDER_PAID"),
					})
					break
				}
				default: {
					const itemsWithSpecificEvent = getItemsWithSpecificEvent(
						orderStatusesEventsMap[status],
						eventResponse
					)
					eventsTimeline.push({
						status: status,
						itemsNumber: itemsWithSpecificEvent.length,
						startDate: getStartDate(itemsWithSpecificEvent),
					})
					break
				}
			}
		})
	}
	return eventsTimeline
}
export const getWarningsCount = (keyEvents: KeyEvent[]): number => {
	if (keyEvents && keyEvents.length > 0) {
		const warnings = keyEvents.filter((keyEvent) => keyEvent.tag.toLowerCase() === "warning")
		return warnings.length
	}
	return 0
}
export const getUpdatesCount = (keyEvents: KeyEvent[]): number => {
	if (keyEvents && keyEvents.length > 0) {
		const updates = keyEvents.filter((keyEvent) => keyEvent.tag.toLowerCase() === "update")
		return updates.length
	}
	return 0
}

export type ItemStatusesMap = {
	[key: string]: string
}
const keyEvents = [
	"ORDER_EMAIL_SENT_ITEM_DELIVERED",
	"LINE_ITEM_FULFILLMENT_SHIPPED",
	"LINE_ITEM_PRODUCTION_STARTED",
	"LINE_ITEM_FULFILLMENT_ACCEPTED",
	"LINE_ITEM_DOC_REVIEW_APPROVED",
	"LINE_ITEM_FULFILLMENT_SEND_SUCCESS",
	"FULFILLMENT_PLATFORM_ACCEPTED",
	"LINE_ITEM_CANCEL_REQUEST_SUCCEEDED",
	"LINE_ITEM_FULFILLMENT_CANCELLED",
	"LINE_ITEM_FULFILLMENT_REJECTED",
]
export const itemStatuses = [
	"Order created",
	"Sent to MCP",
	"Accepted by the platform",
	"Document review approved",
	"Production accepted",
	"Production started",
	"Shipped",
	"Delivered",
]
type StatusEventMap = {
	[key: string]: string
}
export const statusesEventsMap: StatusEventMap = {
	"Order created": "ORDER_CREATED",
	"Sent to MCP": "LINE_ITEM_FULFILLMENT_SEND_SUCCESS",
	"Accepted by the platform": "FULFILLMENT_PLATFORM_ACCEPTED",
	"Document review approved": "LINE_ITEM_DOC_REVIEW_APPROVED",
	"Production accepted": "LINE_ITEM_FULFILLMENT_ACCEPTED",
	"Production started": "LINE_ITEM_PRODUCTION_STARTED",
	Shipped: "LINE_ITEM_FULFILLMENT_SHIPPED",
	Delivered: "ORDER_EMAIL_SENT_ITEM_DELIVERED",
	Cancelled: "LINE_ITEM_CANCEL_REQUEST_SUCCEEDED",
	Rejected: "LINE_ITEM_FULFILLMENT_REJECTED",
}
export const orderStatusesEventsMap: StatusEventMap = {
	"Order created": "ORDER_CREATED",
	"Order paid": "ORDER_PAID",
	"Production started": "LINE_ITEM_PRODUCTION_STARTED",
	"Shipment started": "LINE_ITEM_FULFILLMENT_SHIPPED",
	"Order Delivered": "ORDER_EMAIL_SENT_ITEM_DELIVERED",
}

export const orderStatuses = [
	"Order created",
	"Order paid",
	"Production started",
	"Shipment started",
	"Order Delivered",
]
export interface OrderTimelineDetail {
	status: string
	startDate: string
	itemsNumber?: number
}
export interface ItemTimelineDetail {
	status: string
	date: string
	highlighted: boolean
}
interface itemEvent {
	itemId: string
	event: Event
}
